import { useTheme } from '@/context/ThemeContext';
import { useReportStats } from '@/hooks/useReportStats';

export default function RaporlarPage() {
  const { isDark } = useTheme();
  const { stats, isLoading } = useReportStats();

  const totalFizbo = stats.fizboConversion.kabul + stats.fizboConversion.dusunecek + stats.fizboConversion.red + stats.fizboConversion.baska;

  const hasData = totalFizbo > 0 || stats.portfolioSaleTime.length > 0 || stats.unsoldLoss.totalPortfolioValue > 0;

  if (isLoading) {
    return (
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-purple-500">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-bar-chart-line text-white text-lg" />
            </div>
          </div>
          <div>
            <h1 className={`text-lg font-semibold ${isDark ? 'text-dark-text' : 'text-light-text'}`}>
              Raporlar & Analiz
            </h1>
            <p className={`text-xs ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>
              Performans ve dönüşüm analizleri
            </p>
          </div>
        </div>
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className={`rounded-xl p-4 md:p-5 animate-pulse ${isDark ? 'bg-dark-card border border-dark-border' : 'bg-white border border-light-border'}`}>
            <div className="w-32 h-4 bg-gray-200 dark:bg-gray-700 rounded mb-4" />
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {Array.from({ length: 4 }).map((_, j) => (
                <div key={j} className="h-20 bg-gray-200 dark:bg-gray-700 rounded-lg" />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!hasData) {
    return (
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-purple-500">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-bar-chart-line text-white text-lg" />
            </div>
          </div>
          <div>
            <h1 className={`text-lg font-semibold ${isDark ? 'text-dark-text' : 'text-light-text'}`}>
              Raporlar & Analiz
            </h1>
            <p className={`text-xs ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>
              Performans ve dönüşüm analizleri
            </p>
          </div>
        </div>
        <div className={`rounded-xl p-8 md:p-12 text-center ${isDark ? 'bg-dark-card border border-dark-border' : 'bg-white border border-light-border'}`}>
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-100 dark:bg-dark-border flex items-center justify-center">
            <i className="ri-bar-chart-line text-2xl text-gray-400 dark:text-dark-muted" />
          </div>
          <p className={`text-sm font-medium mb-1 ${isDark ? 'text-dark-text' : 'text-light-text'}`}>
            Henüz yeterli veri yok
          </p>
          <p className={`text-xs ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>
            FİZBO ilan ve portföy ekledikçe burada canlı raporlar görünecek.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-purple-500">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-bar-chart-line text-white text-lg" />
          </div>
        </div>
        <div>
          <h1 className={`text-lg font-semibold ${isDark ? 'text-dark-text' : 'text-light-text'}`}>
            Raporlar & Analiz
          </h1>
          <p className={`text-xs ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>
            Performans ve dönüşüm analizleri
          </p>
        </div>
      </div>

      {/* FİZBO Conversion */}
      {totalFizbo > 0 && (
        <div className={`rounded-xl p-4 md:p-5 ${isDark ? 'bg-dark-card border border-dark-border' : 'bg-white border border-light-border'}`}>
          <h2 className={`text-sm font-semibold mb-4 ${isDark ? 'text-dark-text' : 'text-light-text'}`}>
            FİZBO Dönüşüm Dağılımı
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { label: 'Kabul', value: stats.fizboConversion.kabul, color: 'bg-green-500', textColor: 'text-green-500' },
              { label: 'Düşünecek', value: stats.fizboConversion.dusunecek, color: 'bg-yellow-500', textColor: 'text-yellow-500' },
              { label: 'Red', value: stats.fizboConversion.red, color: 'bg-red-500', textColor: 'text-red-500' },
              { label: 'Başka Emlakçı', value: stats.fizboConversion.baska, color: 'bg-gray-500', textColor: 'text-gray-500' },
            ].map((item) => (
              <div key={item.label} className={`p-3 rounded-lg ${isDark ? 'bg-dark-bg' : 'bg-light-bg'}`}>
                <p className={`text-2xl font-bold ${item.textColor}`}>{item.value}</p>
                <p className={`text-xs mt-1 ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>{item.label}</p>
                <div className={`w-full h-1.5 rounded-full mt-2 ${isDark ? 'bg-dark-border' : 'bg-light-border'}`}>
                  <div className={`h-full rounded-full ${item.color}`} style={{ width: `${totalFizbo > 0 ? (item.value / totalFizbo) * 100 : 0}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Monthly FİZBO */}
      {totalFizbo > 0 && (
        <div className={`rounded-xl p-4 md:p-5 ${isDark ? 'bg-dark-card border border-dark-border' : 'bg-white border border-light-border'}`}>
          <h2 className={`text-sm font-semibold mb-4 ${isDark ? 'text-dark-text' : 'text-light-text'}`}>
            Aylık FİZBO Performansı
          </h2>
          <div className="space-y-3">
            {stats.monthlyFizbo.filter((item) => item.count > 0).map((item) => (
              <div key={item.month} className="flex items-center gap-3">
                <span className={`text-xs w-12 ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>{item.month}</span>
                <div className="flex-1 h-6 rounded-lg bg-gray-100 dark:bg-dark-border overflow-hidden relative">
                  <div
                    className="h-full bg-primary-500 rounded-lg flex items-center justify-end pr-2"
                    style={{ width: `${Math.min(100, (item.count / Math.max(...stats.monthlyFizbo.map((m) => m.count))) * 100)}%` }}
                  >
                    <span className="text-xs text-white font-medium">{item.count}</span>
                  </div>
                </div>
                <span className={`text-xs w-12 text-right ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>
                  {item.kabul} kabul
                </span>
              </div>
            ))}
            {stats.monthlyFizbo.filter((item) => item.count > 0).length === 0 && (
              <p className={`text-xs text-center py-4 ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>
                Henüz aylık veri bulunmuyor
              </p>
            )}
          </div>
        </div>
      )}

      {/* Portfolio Sale Time */}
      {stats.portfolioSaleTime.length > 0 && (
        <div className={`rounded-xl p-4 md:p-5 ${isDark ? 'bg-dark-card border border-dark-border' : 'bg-white border border-light-border'}`}>
          <h2 className={`text-sm font-semibold mb-4 ${isDark ? 'text-dark-text' : 'text-light-text'}`}>
            Portföy Satış Süresi (Ortalama)
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {stats.portfolioSaleTime.map((item) => (
              <div key={item.type} className={`p-4 rounded-lg text-center ${isDark ? 'bg-dark-bg' : 'bg-light-bg'}`}>
                <p className={`text-2xl font-bold ${isDark ? 'text-dark-text' : 'text-light-text'}`}>{item.avgDays}</p>
                <p className={`text-xs mt-1 ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>gün</p>
                <p className={`text-sm font-medium mt-2 ${isDark ? 'text-dark-text' : 'text-light-text'}`}>{item.type}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Revenue */}
      {totalFizbo > 0 && (
        <div className={`rounded-xl p-4 md:p-5 ${isDark ? 'bg-dark-card border border-dark-border' : 'bg-white border border-light-border'}`}>
          <h2 className={`text-sm font-semibold mb-4 ${isDark ? 'text-dark-text' : 'text-light-text'}`}>
            Aylık Komisyon Geliri
          </h2>
          <div className="space-y-3">
            {stats.monthlyRevenue.filter((item) => item.revenue > 0).map((item) => (
              <div key={item.month} className="flex items-center gap-3">
                <span className={`text-xs w-12 ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>{item.month}</span>
                <div className="flex-1 h-6 rounded-lg bg-gray-100 dark:bg-dark-border overflow-hidden relative">
                  <div
                    className="h-full bg-secondary-500 rounded-lg flex items-center justify-end pr-2"
                    style={{ width: `${Math.min(100, (item.revenue / Math.max(...stats.monthlyRevenue.map((m) => m.revenue))) * 100)}%` }}
                  >
                    <span className="text-xs text-white font-medium">{(item.revenue / 1000).toFixed(0)}K</span>
                  </div>
                </div>
                <span className={`text-xs w-16 text-right font-medium ${isDark ? 'text-dark-text' : 'text-light-text'}`}>
                  {item.revenue.toLocaleString('tr-TR')} ₺
                </span>
              </div>
            ))}
            {stats.monthlyRevenue.filter((item) => item.revenue > 0).length === 0 && (
              <p className={`text-xs text-center py-4 ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>
                Henüz kapanmış ilan bulunmuyor
              </p>
            )}
          </div>
        </div>
      )}

      {/* Unsold Loss Card */}
      {stats.unsoldLoss.totalPortfolioValue > 0 && (
        <div className={`rounded-xl p-4 md:p-5 ${isDark ? 'bg-dark-card border border-dark-border' : 'bg-white border border-light-border'}`}>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-lg bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
              <i className="ri-alert-line text-red-500" />
            </div>
            <h2 className={`text-sm font-semibold ${isDark ? 'text-dark-text' : 'text-light-text'}`}>
              Satılmayan Mülk Zararı
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <div className={`p-4 rounded-lg ${isDark ? 'bg-dark-bg' : 'bg-light-bg'}`}>
              <p className={`text-xs ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>Aylık Faiz Kaybı</p>
              <p className={`text-xl font-bold mt-1 text-red-500`}>
                {stats.unsoldLoss.monthlyInterestLoss.toLocaleString('tr-TR')} ₺
              </p>
            </div>
            <div className={`p-4 rounded-lg ${isDark ? 'bg-dark-bg' : 'bg-light-bg'}`}>
              <p className={`text-xs ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>Aylık Enflasyon Kaybı</p>
              <p className={`text-xl font-bold mt-1 text-orange-500`}>
                {stats.unsoldLoss.monthlyInflationLoss.toLocaleString('tr-TR')} ₺
              </p>
            </div>
            <div className={`p-4 rounded-lg ${isDark ? 'bg-dark-bg' : 'bg-light-bg'}`}>
              <p className={`text-xs ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>Ort. Bekleme Süresi</p>
              <p className={`text-xl font-bold mt-1 ${isDark ? 'text-dark-text' : 'text-light-text'}`}>
                {stats.unsoldLoss.avgDaysUnsold} gün
              </p>
            </div>
          </div>
          <div className={`mt-4 p-3 rounded-lg ${isDark ? 'bg-dark-bg' : 'bg-light-bg'}`}>
            <p className={`text-xs ${isDark ? 'text-dark-muted' : 'text-light-muted'}`}>
              Toplam portföy değeri: <span className={`font-medium ${isDark ? 'text-dark-text' : 'text-light-text'}`}>
                {stats.unsoldLoss.totalPortfolioValue.toLocaleString('tr-TR')} ₺
              </span>
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
